import React, { useEffect, useState } from "react";
import { createPortal } from "react-dom";
import ProfileCard from "../../../Identity/CurrentYou/ProfileCard";
import FutureIdentityCard from "../../../Identity/FutureYou/FutureIdentityCard";
import stars from "../../../../../../../assets/stars.png";
import { progressService } from "../../../../../../../services/progressService";

const FutureValuesFinalResult = ({
  currentIdentityData = {},
  futureData = {},
  top3Values = [],
  currentValuesMapping = [],
  userName = "User",
  profileImage = null,
  userId,
  subsectionId,
  onSubsectionChange,
  onComplete,
  actions,
}) => {
  const [unmetNeedsData, setUnmetNeedsData] = useState([]);
  // eslint-disable-next-line no-unused-vars
  const [selectedCards, setSelectedCards] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  const NEXT_SUBSECTION_ID = "c27e1c15-4f29-48df-898b-628cd04899a7";

  useEffect(() => {
    const fetchUnmetNeeds = async () => {
      if (!userId) {
        setIsLoading(false);
        return;
      }

      try {
        const UNMET_NEEDS_SUBSECTION_ID = "2d691202-ec05-43fa-a557-ff9d1c709929";
        const record = await progressService.getUserProgress(userId, UNMET_NEEDS_SUBSECTION_ID);
        
        if (record?.data) {
          setUnmetNeedsData(record.data.selectedCardsData || []);
          setSelectedCards(record.data.selectedCards || []);
        }
      } catch (error) {
        console.error("Error fetching unmet needs:", error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchUnmetNeeds();
  }, [userId]);

  useEffect(() => {
    const navigationTimer = setTimeout(() => {
      if (onSubsectionChange) {
        onSubsectionChange(NEXT_SUBSECTION_ID);
      }
    }, 5000);

    return () => clearTimeout(navigationTimer);
  }, [onSubsectionChange]);

  useEffect(() => {
    if (!actions) return;
    actions.clearPrimary?.();
    return () => actions.clearPrimary?.();
  }, [actions]);

  const currentProfileData = {
    userName: userName,
    profileImage: profileImage || currentIdentityData?.profileImage || null,
    currentTitle: currentIdentityData?.currentTitle || "SOFTWARE ENGINEER",
    location: currentIdentityData?.location || null,
    salary: currentIdentityData?.salary || null,
    experienceYears: currentIdentityData?.experienceYears || null,
    experienceMonths: currentIdentityData?.experienceMonths || null,
    technicalSkills: currentIdentityData?.technicalSkills || null,
    behaviors: currentIdentityData?.behaviors || null,
    advice: currentIdentityData?.advice || null,
    hobbies: currentIdentityData?.hobbies || null,
  };

  return createPortal(
    <div className="fixed inset-0 z-[9999] bg-white overflow-y-auto flex flex-col items-center justify-start py-8">
      <div 
        style={{
          position: "relative",
          display: "flex",
          alignItems: "flex-start",
          justifyContent: "center",
          gap: "410px",
          width: "100%",
          height: "auto",
          paddingBottom: "40px",
        }}
      >
        <div
          style={{
            width: "429px",
            height: "auto",
            borderRadius: "25px",
            border: "1px solid #E0E0E0",
            boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
            backgroundColor: "white",
            overflow: "hidden",
            position: "relative",
            zIndex: 2,
            flexShrink: 0,
          }}
        >
          <ProfileCard
            formData={currentProfileData}
            onInputChange={() => {}}
            headerLabel="YOUR CURRENT STATE"
            editableName={false}
            showKnownFor={true}
            showCoreValues={true}
            coreValues={currentValuesMapping} 
          />
        </div>

        <div
          style={{
            position: "absolute",
            width: "410px",
            height: "auto",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            zIndex: 10,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <div
            style={{
              position: "absolute",
              top: "50%",
              left: "0",
              right: "0",
              height: "3px",
              background: "#D9D9D9",
              transform: "translateY(-50%)",
              zIndex: 1,
            }}
          />

          <div 
            className="bg-white flex flex-col items-center relative overflow-hidden" 
            style={{ 
              zIndex: 15,
              width: "303.95px",
              borderRadius: "17.71px",
              border: "0.71px solid #707070",
            }}
          >
            
            <div className="bg-[#0D1111] text-white w-full flex items-center justify-center gap-3" 
              style={{ height: "115px", borderRadius: "17.71px 17.71px 0 0" }}>
              <img src={stars} alt="Stars" className="w-6 h-6 rotate-180 opacity-90" />
              <h1 className="text-2xl text-white font-bold font-gotham tracking-wide">
                UNMET NEEDS
              </h1>
              <img src={stars} alt="Stars" className="w-6 h-6 opacity-90" />
            </div>

            {!isLoading && unmetNeedsData.length > 0 && (
              <div className="w-full flex justify-center -mt-5 z-10">
                <div
                  style={{
                    width: "241.60px",
                    height: "auto",
                    borderRadius: "7.09px",
                    border: "0.71px solid #CCCCCC",
                    paddingTop: "8.5px",
                    paddingRight: "41.8px",
                    paddingBottom: "8.5px",
                    paddingLeft: "41.8px",
                    gap: "7.09px",
                    background: "#F8F8F8",
                  }}
                  className="text-center font-gotham font-medium text-[#1D1D1D] shadow-sm"
                >
                  {unmetNeedsData[0].label}
                </div>
              </div>
            )}

            <div className="w-full px-6 pb-6 mt-3 flex flex-col gap-2">
              {!isLoading && unmetNeedsData.length > 1 ? (
                unmetNeedsData.slice(1).map(need => (
                  <div
                    key={need.id}
                    style={{
                      width: "241.60px",
                      height: "auto",
                      borderRadius: "7.09px",
                      border: "0.71px solid #E0E0E0",
                      paddingTop: "8.5px",
                      paddingRight: "41.8px",
                      paddingBottom: "8.5px",
                      paddingLeft: "41.8px",
                      gap: "7.09px",
                      background: "white",
                    }}
                    className="text-center font-gotham font-medium text-[#1D1D1D] shadow-sm hover:bg-[#F8F8F8] transition"
                  >
                    {need.label}
                  </div>
                ))
              ) : isLoading ? (
                <div className="text-center text-gray-400">Loading...</div>
              ) : (
                <div className="text-center text-gray-400">No unmet needs</div>
              )}
            </div>
          </div>
        </div>

        <div
          style={{
            width: "429px",
            height: "auto",
            borderRadius: "25px",
            border: "1px solid #E0E0E0",
            boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
            backgroundColor: "white",
            overflow: "hidden",
            position: "relative",
            zIndex: 2,
            flexShrink: 0,
          }}
        >
          <FutureIdentityCard
            futureData={futureData}
            userName={userName}
            profileImage={futureData?.profileImage || profileImage}
            currentInput=""
            coreValues={top3Values}
            showCoreValues={true}
          />
        </div>
      </div>
    </div>,
    document.body
  );
};

export default FutureValuesFinalResult;


// import React, { useEffect, useState } from "react";
// import { createPortal } from "react-dom";
// import ProfileCard from "../../../Identity/CurrentYou/ProfileCard";
// import FutureIdentityCard from "../../../Identity/FutureYou/FutureIdentityCard";
// import stars from "../../../../../../../assets/stars.png";
// import { progressService } from "../../../../../../../services/progressService";


// const FutureValuesFinalResult = ({
//   currentIdentityData = {},
//   futureData = {},
//   top3Values = [],
//   currentValuesMapping = [],
//   userName = "User",
//   profileImage = null,
//   userId,
//   subsectionId,  // ✅ ADD THIS
//   onSubsectionChange,  // ✅ ADD THIS
//   onComplete
// }) => {
//   const [unmetNeedsData, setUnmetNeedsData] = useState([]);
//   const [selectedCards, setSelectedCards] = useState([]);
//   const [isLoading, setIsLoading] = useState(true);

//   // ✅ Constants
//   const NEXT_SUBSECTION_ID = "c27e1c15-4f29-48df-898b-628cd04899a7";

//   useEffect(() => {
//     const fetchUnmetNeeds = async () => {
//       if (!userId) {
//         setIsLoading(false);
//         return;
//       }

//       try {
//         const UNMET_NEEDS_SUBSECTION_ID = "2d691202-ec05-43fa-a557-ff9d1c709929";
//         const record = await progressService.getUserProgress(userId, UNMET_NEEDS_SUBSECTION_ID);
        
//         if (record?.data) {
//           setUnmetNeedsData(record.data.selectedCardsData || []);
//           setSelectedCards(record.data.selectedCards || []);
//         }
//       } catch (error) {
//         console.error("Error fetching unmet needs:", error);
//       } finally {
//         setIsLoading(false);
//       }
//     };

//     fetchUnmetNeeds();
//   }, [userId]);

//   // ✅ AUTO-NAVIGATE AFTER 2 SECONDS
//   useEffect(() => {
//     const navigationTimer = setTimeout(() => {
//       if (onSubsectionChange) {
//         onSubsectionChange(NEXT_SUBSECTION_ID);
//       }
//     }, 5000); 

//     return () => clearTimeout(navigationTimer);
//   }, [onSubsectionChange]);

//   const currentProfileData = {
//     userName: userName,
//     profileImage: profileImage || currentIdentityData?.profileImage || null,
//     currentTitle: currentIdentityData?.currentTitle || "SOFTWARE ENGINEER",
//     location: currentIdentityData?.location || null,
//     salary: currentIdentityData?.salary || null,
//     experienceYears: currentIdentityData?.experienceYears || null,
//     experienceMonths: currentIdentityData?.experienceMonths || null,
//     technicalSkills: currentIdentityData?.technicalSkills || null,
//     behaviors: currentIdentityData?.behaviors || null,
//     advice: currentIdentityData?.advice || null,
//     hobbies: currentIdentityData?.hobbies || null,
//   };

//   return createPortal(
//     <div className="fixed inset-0 z-[9999] bg-white overflow-y-auto flex flex-col items-center justify-start py-8">
//       <div 
//         style={{
//           position: "relative",
//           display: "flex",
//           alignItems: "flex-start",
//           justifyContent: "center",
//           gap: "410px",
//           width: "100%",
//           height: "auto",
//           paddingBottom: "40px",
//         }}
//       >
//         {/* LEFT CARD - Current State */}
//         <div
//           style={{
//             width: "429px",
//             height: "auto",
//             borderRadius: "25px",
//             border: "1px solid #E0E0E0",
//             boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
//             backgroundColor: "white",
//             overflow: "hidden",
//             position: "relative",
//             zIndex: 2,
//             flexShrink: 0,
//           }}
//         >
//           <ProfileCard
//             formData={currentProfileData}
//             onInputChange={() => {}}
//             headerLabel="YOUR CURRENT STATE"
//             editableName={false}
//             showKnownFor={true}
//             showCoreValues={true}
//             coreValues={currentValuesMapping} 
//           />
//         </div>

//         {/* CENTER: HORIZONTAL LINE WITH UNMET NEEDS BOX */}
//         <div
//           style={{
//             position: "absolute",
//             width: "410px",
//             height: "auto",
//             top: "50%",
//             left: "50%",
//             transform: "translate(-50%, -50%)",
//             zIndex: 10,
//             display: "flex",
//             alignItems: "center",
//             justifyContent: "center",
//           }}
//         >
//           {/* Horizontal Gray Line */}
//           <div
//             style={{
//               position: "absolute",
//               top: "50%",
//               left: "0",
//               right: "0",
//               height: "3px",
//               background: "#D9D9D9",
//               transform: "translateY(-50%)",
//               zIndex: 1,
//             }}
//           />

//           {/* UNMET NEEDS CARD */}
//           <div 
//             className="bg-white flex flex-col items-center relative overflow-hidden" 
//             style={{ 
//               zIndex: 15,
//               width: "303.95px",
//               borderRadius: "17.71px",
//               border: "0.71px solid #707070",
//             }}
//           >
            
//             {/* Black Header */}
//             <div className="bg-[#0D1111] text-white w-full flex items-center justify-center gap-3" 
//               style={{ height: "115px", borderRadius: "17.71px 17.71px 0 0" }}>
//               <img src={stars} alt="Stars" className="w-6 h-6 rotate-180 opacity-90" />
//               <h1 className="text-2xl text-white font-bold font-gotham tracking-wide">
//                 UNMET NEEDS
//               </h1>
//               <img src={stars} alt="Stars" className="w-6 h-6 opacity-90" />
//             </div>

//             {/* Floating First Card */}
//             {!isLoading && unmetNeedsData.length > 0 && (
//               <div className="w-full flex justify-center -mt-5 z-10">
//                 <div
//                   style={{
//                     width: "241.60px",
//                     height: "auto",
//                     borderRadius: "7.09px",
//                     border: "0.71px solid #CCCCCC",
//                     paddingTop: "8.5px",
//                     paddingRight: "41.8px",
//                     paddingBottom: "8.5px",
//                     paddingLeft: "41.8px",
//                     gap: "7.09px",
//                     background: "#F8F8F8",
//                   }}
//                   className="text-center font-gotham font-medium text-[#1D1D1D] shadow-sm"
//                 >
//                   {unmetNeedsData[0].label}
//                 </div>
//               </div>
//             )}

//             {/* Remaining List */}
//             <div className="w-full px-6 pb-6 mt-3 flex flex-col gap-2">
//               {!isLoading && unmetNeedsData.length > 1 ? (
//                 unmetNeedsData.slice(1).map(need => (
//                   <div
//                     key={need.id}
//                     style={{
//                       width: "241.60px",
//                       height: "auto",
//                       borderRadius: "7.09px",
//                       border: "0.71px solid #E0E0E0",
//                       paddingTop: "8.5px",
//                       paddingRight: "41.8px",
//                       paddingBottom: "8.5px",
//                       paddingLeft: "41.8px",
//                       gap: "7.09px",
//                       background: "white",
//                     }}
//                     className="text-center font-gotham font-medium text-[#1D1D1D] shadow-sm hover:bg-[#F8F8F8] transition"
//                   >
//                     {need.label}
//                   </div>
//                 ))
//               ) : isLoading ? (
//                 <div className="text-center text-gray-400">Loading...</div>
//               ) : (
//                 <div className="text-center text-gray-400">No unmet needs</div>
//               )}
//             </div>
//           </div>
//         </div>

//         {/* RIGHT CARD - Future State */}
//         <div
//           style={{
//             width: "429px",
//             height: "auto",
//             borderRadius: "25px",
//             border: "1px solid #E0E0E0",
//             boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
//             backgroundColor: "white",
//             overflow: "hidden",
//             position: "relative",
//             zIndex: 2,
//             flexShrink: 0,
//           }}
//         >
//           <FutureIdentityCard
//             futureData={futureData}
//             userName={userName}
//             profileImage={futureData?.profileImage || profileImage}
//             currentInput=""
//             coreValues={top3Values}
//             showCoreValues={true}
//           />
//         </div>
//       </div>
//     </div>,
//     document.body
//   );
// };

// export default FutureValuesFinalResult;
